import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont, faFlag } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../contexts/LanguageContext';

const CodeDifficultySelection = ({ onSelectDifficulty, onBack }) => {
  const { t } = useLanguage();

  return (
    <div className="difficulty-selection">
      <button className="back-button" onClick={onBack}>{t('back')}</button>
      <h2>{t('chooseDifficultyTitleCode')}</h2>
      <div className="difficulty-buttons">
        <div className="difficulty-btn easy" onClick={() => onSelectDifficulty('easy')}>
          <div className="difficulty-icon">
            <FontAwesomeIcon icon={faFont} />
          </div>
          <h3>{t('easyMode')}</h3>
          <p>{t('easyDescriptionCode')}</p>
        </div>
        <div className="difficulty-btn hard" onClick={() => onSelectDifficulty('hard')}>
          <div className="difficulty-icon">
            <FontAwesomeIcon icon={faFlag} />
          </div>
          <h3>{t('hardMode')}</h3>
          <p>{t('hardDescriptionCode')}</p>
        </div>
      </div>
    </div>
  );
};

export default CodeDifficultySelection;